import { render, staticRenderFns } from "./TitleInfo.vue?vue&type=template&id=b4c46dfa"
import script from "./TitleInfo.vue?vue&type=script&lang=js"
export * from "./TitleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports